import React, { Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { Layout } from 'antd';
import Loader from '../../components/Loader/Loader';
import MainHeader from './Components/MainHeader';
import MainFooter from './Components/MainFooter';
import ThemeLoader from "../../components/Loader/ThemeLoader";

import { route } from '../../routes';

import './style.less'

const loading = () => (
    <>
        <Loader />
    </>
);

const { Content } = Layout;

const LandingLayout = () => {

    return <>
        <Layout className="landing-layout">
            <ThemeLoader />
            <MainHeader />
            <Content className="landing-layout-content">
                <Suspense fallback={loading()}>
                    <Switch>
                        {route.map((route, idx) => {
                            return route.component ? (
                            <Route
                                key={idx}
                                path={route.path}
                                exact={route.exact}
                                name={route.name}
                                render={(props) => <route.component {...props} />}
                            />
                            ) : null;
                        })}
                        <Redirect from="/" to="/home" />
                    </Switch>
                </Suspense>
            </Content>
            <MainFooter />
        </Layout>
    </>
};

export default LandingLayout;